export default function BannerArraySkeleton() {
  return (
    <div className="flex flex-wrap -mt-2.5 pr-2.5">
      {new Array(4).fill(0).map((_item, index) => {
        return (
          <div key={`banner-${index}`} className="w-1/2 pl-2.5 pt-2.5 flex-shrink-0 box-border">
            <div className=" box-border p-2.5 rounded-500 h-[90px] flex items-center bg-surface-200-bg skeleton"></div>
          </div>
        );
      })}
    </div>
  );
}
